export default __webpack_public_path__ + "static/hw_ssd1306-79ab7cc3c56cfa5f4031da113f9471b4.jpg";